<template>
  <SmsAuthWithPhoneSwitch
    v-if="isSms"
    title="パスワード再設定"
    :phoneNumber="phoneNumber"
    :createSms="createSms"
    :validateSms="validateSms"
    @switchToVoice="switchProvider('phone')"
    @validated="onValidated"
  />
  <PhoneAuth
    v-else-if="isVoice"
    title="電話番号認証"
    :phoneNumber="phoneNumber"
    :createPhoneRequest="createPhoneRequest"
    :validatePhoneRequest="validatePhoneRequest"
    @switchToSMS="switchProvider('sms')"
    @validated="onValidated"
  />
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { smsService } from "@/app/services/SmsService";
import { authStore } from "@/store/auth";
import SmsAuthWithPhoneSwitch from "@/components/organisms/auth/SmsAuthWithPhoneSwitch.vue";
import { CreateSmsArgs } from "@/types/auth/CreateSms";
import { ValidateSmsArgs } from "@/types/auth/ValidateSms";
import PhoneAuth from "@/components/organisms/auth/PhoneAuth.vue";
import { ProviderType } from "@/const/auth";
import { CreatePhoneRequestArgs } from "@/types/auth/CreatePhoneRequest";
import { ValidatePhoneRequestArgs } from "@/types/auth/ValidatePhoneRequest";

@Component({
  components: {
    SmsAuthWithPhoneSwitch,
    PhoneAuth
  }
})
export default class PhoneNumberAuth extends Vue {
  providerType: ProviderType = "sms";

  get phoneNumber() {
    if (this.isLoggedIn) {
      return authStore.user?.workerPhoneNumber;
    } else {
      return authStore.temporaryPhoneNumber;
    }
  }

  get isSms() {
    return this.providerType === "sms";
  }

  get isVoice() {
    return this.providerType === "phone";
  }

  get isLoggedIn() {
    return authStore.existToken;
  }

  switchProvider(provider: ProviderType) {
    this.providerType = provider;
  }

  createSms(body: CreateSmsArgs) {
    return smsService.createSmsPasswordReset(body);
  }

  validateSms(body: ValidateSmsArgs) {
    return smsService.validateSmsPasswordReset(body);
  }

  createPhoneRequest(body: CreatePhoneRequestArgs) {
    return smsService.createPhoneRequest(body);
  }

  validatePhoneRequest(body: ValidatePhoneRequestArgs) {
    return smsService.validatePhoneRequest(body);
  }

  onValidated(smsSessionId: string) {
    authStore.changeSmsSessionId(smsSessionId);
    this.$router.push({ name: "ResetPasswordSetting" });
  }
}
</script>
